export default __webpack_public_path__ + "static/media/slide1.fc2cc8b8.jpg";